import React from 'react';
import { Controller } from 'react-hook-form';
import InputComponent from 'src/common-ui/input/input.component';
export const FormInputComponent = (props) => (React.createElement(Controller, { name: props.name, control: props.control, render: ({ field: { onChange, value }, fieldState: { error } }) => {
        var _a;
        return (React.createElement(InputComponent, Object.assign({}, props, { value: value, onChange: (_a = props.customOnChange) !== null && _a !== void 0 ? _a : onChange, error: error })));
    } }));
